// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"VZ-z","sponsoredTooltipWrapper":"WZ-z","sponsoredTooltip":"XZ-z","newCard":"YZ-z"};